export const Languages = ["English", "Spanish"];
